import {
  REACT_APP_VIEW_DASHBOARD_PERFORMANCE_USERS,
  REACT_APP_SUPER_CLIENTS,
  REACT_APP_TENANT_SELECTOR_ALLOWLIST,
  REACT_APP_ENABLE_CUSTOMER_LIST,
  REACT_APP_GOOGLE_MAPS_KEY,
  REACT_APP_PF_ADMIN_ID,
  REACT_APP_CONFIGURATION_AUDIT_LOG_ENABLED,
  REACT_APP_AUDIT_TAB_ENABLED,
  REACT_APP_PF_CSV_UPLOAD_SIZE,
  REACT_APP_STATUS_MAX_ATTEMPTS,
  REACT_APP_STATUS_POLL_INTERVAL,
} from './constants/envConstants';
import { URL_CONSTANTS } from './constants/urlConstants';
import { isRingCentralEnabled } from './components/shared/Topbar/components/ringCentral/ringCentralConfig';

export let clientDetails = JSON.parse(
  localStorage.getItem('client_details') || '{}'
);

export const CLIENT_DETAILS_UPDATED_EVENT = 'client-details-updated';

export const isNoCodeLowCodeModuleEnabled = (details = clientDetails) =>
  Number(details?.no_code_low_code_module) === 1;

export const isCompanyParentChildAllocationEnabled = (
  details = clientDetails
) =>
  Number(
    details?.company_parent_child_allocation ??
      details?.tenant_configuration?.company_parent_child_allocation ??
      0
  ) === 1;

export const updateClientDetails = clientDetailsParams => {
  clientDetails = clientDetailsParams;

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CLIENT_DETAILS_UPDATED_EVENT));
  }
};

export const clientRolePermission = JSON.parse(
  localStorage.getItem('permissions') || '[]'
);

export const CLIENT_DETAILS = Object.freeze({
  ...clientDetails,
});

export const VIEW_DASHBOARD_PERFORMANCE_USERS =
  REACT_APP_VIEW_DASHBOARD_PERFORMANCE_USERS
    ? REACT_APP_VIEW_DASHBOARD_PERFORMANCE_USERS.split(',')
    : [];

export const COVERAGE_BY = {
  ZIPCODE: 1,
  STORE: 2,
  DISTRICT: 3,
};

export const ISSUE_DEFAULT_STATUS = 'OPEN';

export const QUICK_ACTION_TYPE = {
  BUSTED_JOB: 'busted-job',
  BUSTED_TITLE: 'Busted Reason',
  NOTES_TITLE: 'Note',
  READY_TO_SCHEDULE: 'ready-to-schedule',
  DECLINE_LEAD: 'decline-lead',
};

export const SUPER_CLIENTS = REACT_APP_SUPER_CLIENTS
  ? JSON.parse(REACT_APP_SUPER_CLIENTS)
  : [];

export const TENANT_SELECTOR_ALLOWLIST = REACT_APP_TENANT_SELECTOR_ALLOWLIST
  ? JSON.parse(REACT_APP_TENANT_SELECTOR_ALLOWLIST)
  : [];

// ENUM for Yes/No Dropdown
export const YesNoDropdown = [
  {
    id: 1,
    value: 'Yes',
  },
  {
    id: 0,
    value: 'No',
  },
];

export const isLeadRequiredDropdown = [
  {
    id: null,
    value: 'All',
  },
  ...YesNoDropdown,
];

export const PropertyOccupationDropdown = [
  {
    key: 'Owner',
    value: 'Owner',
  },
  {
    key: 'Tenant',
    value: 'Tenant',
  },
];

// ENUM for status colors
export const StatusColors = {
  PF_GREEN: '#2CAA42',
  PF_YELLOW: '#FF8800',
  PF_RED: '#FF0D00',
  PF_LIGHT_RED: '#FFC3C1',
  PF_LIGHT_GREEN: '#DDF7D5',
  PF_LIGHT_YELLOW: '#FFF3CD',
  PF_GRAY: '#777e98',
  PF_RED_ORANGE: '#f44336',
  PF_PALE_YELLOW: '#FBE253',
};

export const Colors = {
  PF_GREYBORDER: '#CCCCCC',
  PF_BORDER: '#E5E8EB',
  PF_WIDGETCOLOR: '#B9BCBF',
  PF_WHITE: '#FFFFFF',
  PF_GRAY: '#BDBDBD',
  PF_BLACK: ' #000000',
  PF_BLUE: '#0000ff',
  PF_VIVOLET: '#5e5ba6',
  PF_SILVER_PINK: '#C6AAA7',
  PF_VERY_SOFT_BLUE: '#daf7fe',
  PF_LIGHT_BLUE: '#279BFF',
  PF_MOBILE_COLOR: '#1391FF',
};
// Options for Search Params
export const GLOBAL_SEARCH_PARAMETERS_OPTIONS = [
  {
    label: 'Project#',
    value: 'project_number',
  },
  {
    label: 'PO#',
    value: 'po_number',
  },
  {
    label: 'Client',
    value: 'client',
  },
  {
    label: 'Phone',
    value: 'phone',
  },
  {
    label: 'Address',
    value: 'address',
  },
];

// Options for Widget Type
export const WidgetTypeOptions = [
  {
    key: 'bar-chart',
    value: 'Bar Chart',
  },
  {
    key: 'external-link-button',
    value: 'Button',
  },
  {
    key: 'card',
    value: 'Card',
  },
  {
    key: 'gauge',
    value: 'Gauge',
  },
  {
    key: 'line-chart',
    value: 'Line',
  },
  {
    key: 'pie-chart',
    value: 'Pie Chart',
  },
  {
    key: 'table-report',
    value: 'Tabular Report',
  },
  {
    key: 'progress-bar',
    value: 'Progress Bar',
  },
  {
    key: 'stacked-bar',
    value: 'Stacked Bar',
  },
  {
    key: 'grouped-bar',
    value: 'Grouped Bar',
  },
];

// Options for Menu List
export const getMenuList = () => {
  return [
    {
      route: '/dashboard',
      value: 'Home',
      icon: 'Home',
      subMenu: [],
      permission: 'HOME_M',
    },
    {
      route: '',
      value: 'Project',
      icon: 'Project',
      subMenu: [
        {
          route: '/scheduler',
          value: 'Scheduler',
          subMenu: [],
          permission: 'SCHEDULER_M',
        },
        {
          route: '/project/clients',
          value: 'Clients',
          subMenu: [],
          permission: 'CLIENTS_M',
        },
        {
          route: '/project/items',
          value: 'Items',
          subMenu: [],
          permission: 'ITEMS_M',
        },
        {
          route: '/project/add',
          value: 'Add Project',
          subMenu: [],
          permission: 'ADD_PROJECT',
        },
        {
          route: '/project/add-fields',
          value: 'Add Project Fields',
          subMenu: [],
          permission: 'ADD_PROJECT_FIELDS_VIEW',
        },
        {
          route: '/payment-request',
          value: 'Payment Request',
          subMenu: [],
          permission: 'ADD_PROJECT',
        },
      ],
      permission: 'PROJECT_M',
    },
    {
      route: '',
      value: 'Admin',
      icon: 'Admin',
      subMenu: [
        {
          route: '/admin/laborprofiles',
          value: 'Labor Profiles',
          subMenu: [],
          permission: 'LABOR_PROFILES_M',
        },
        {
          route: '/admin/usermanagement',
          value: 'User Management',
          subMenu: [],
          permission: 'USER_MGMT_M',
        },
        {
          route: '/admin/municipality-management',
          value: 'Municipality Registration',
          subMenu: [],
          permission: 'VIEW_MUNICIPALITY_REGISTRATION',
        },
        {
          route: '/admin/stores',
          value: 'Stores',
          subMenu: [],
          permission: 'STORE_M',
        },
        {
          route: '/admin/dashboards',
          value: 'Dashboards',
          subMenu: [],
          permission: 'DASHBOARD_MGMT_M',
        },
        {
          route: '/admin/widgets',
          value: 'Widgets',
          subMenu: [],
          permission: 'DASHBOARD_WIDGET_TEMPLATE',
        },
        {
          route: '/admin/documentcenter',
          value: 'Document Center',
          subMenu: [],
          permission: 'DOC_CENTER_M',
        },
        {
          route: '/admin/ruleenginelogs',
          value: 'Event Logs',
          subMenu: [],
          permission: 'RULE_ENGINE_LOGS_VIEW',
        },
        // {
        //   route: '/admin/engine-result',
        //   value: 'Engine Result',
        //   subMenu: [],
        //   permission: 'RULE_ENGINE_LOGS_VIEW',
        // },
        {
          route: '/admin/tenant-billing',
          value: 'Tenant Billing',
          subMenu: [],
          permission: 'CONFIGURATION_M',
        },
        {
          route: '/admin/configuration',
          value: 'Configuration',
          subMenu: [],
          permission: 'CONFIGURATION_M',
        },
        {
          route: '/admin/checklist',
          value: 'Checklist',
          subMenu: [],
          permission: 'QUESTIONNAIRE_VIEW',
        },
        {
          route: '/admin/bulletin',
          value: 'Bulletin',
          subMenu: [],
          permission: 'CONFIGURATION_M',
        },
        ...(isRingCentralEnabled()
          ? [
              {
                route: '/call-history',
                value: 'Call History',
                subMenu: [],
                permission: 'HOME_M',
              },
            ]
          : []),
        {
          route: '/project/chargeback/add',
          value: 'Add Chargeback',
          subMenu: [],
          permission: 'ADD_APPROVE_CHARGEBACK',
        },
      ],
      permission: 'ADMIN_M',
    },
    {
      route: '',
      value: 'Personnel',
      icon: 'Project',
      subMenu: [
        {
          route: '/personnel/availabilityupdates',
          value: 'Availability Updates',
          subMenu: [],
          permission: 'AVAILABILITY_UPDATE_M',
        },
      ],
      permission: 'PERSONNEL_M',
    },
  ];
};

// Options for filters operator
export const FiltersOperators = [
  {
    key: 'equals',
    value: 'Equals',
    type: 'string',
  },
  {
    key: 'notEquals',
    value: 'Not Equals',
    type: 'string',
  },
  {
    key: 'contains',
    value: 'Contains',
    type: 'string',
  },
  {
    key: 'notContains',
    value: 'Not Contains',
    type: 'string',
  },
  {
    key: 'set',
    value: 'Not Empty',
    type: 'string',
  },
  {
    key: 'notSet',
    value: 'Empty',
    type: 'string',
  },
  {
    key: 'beforeDate',
    value: 'Before Date',
    type: 'time',
  },
  {
    key: 'afterDate',
    value: 'After Date',
    type: 'time',
  },
];

export const NumberFiltersOperators = [
  {
    key: 'equals',
    value: 'Equals',
    type: 'string',
  },
  {
    key: 'notEquals',
    value: 'Not Equals',
    type: 'string',
  },
  {
    key: 'set',
    value: 'Not Empty',
    type: 'string',
  },
  {
    key: 'notSet',
    value: 'Empty',
    type: 'string',
  },
  {
    key: 'gt',
    value: 'Greater Than',
    type: 'string',
  },
  {
    key: 'gte',
    value: 'Greater Than Equals To',
    type: 'string',
  },
  {
    key: 'lt',
    value: 'Less Than',
    type: 'string',
  },
  {
    key: 'lte',
    value: 'Less Than Equals To',
    type: 'string',
  },
];

export const FiltersOperatorsForDate = [
  {
    key: 'equals',
    value: 'Equals',
    type: 'string',
  },
  {
    key: 'notEquals',
    value: 'Not Equals',
    type: 'string',
  },
  {
    key: 'beforeDate',
    value: 'Before Date',
    type: 'time',
  },
  {
    key: 'afterDate',
    value: 'After Date',
    type: 'time',
  },
];

export const mockFilterDataByDimension = {
  current_activity: [
    {
      label: 'Refigure Request',
      value: 'Refigure Request',
    },
    {
      label: 'Reschedule',
      value: 'Reschedule',
    },
    {
      label: 'Ready to Schedule',
      value: 'Ready to Schedule',
    },
    {
      label: 'Work Complete',
      value: 'Work Complete',
    },
    {
      label: 'Submit Documents',
      value: 'Submit Documents',
    },
    {
      label: 'Inspection Results',
      value: 'Inspection Results',
    },
    {
      label: 'Pull Permit',
      value: 'Pull Permit',
    },
    {
      label: 'Schedule Inspection',
      value: 'Schedule Inspection',
    },
    {
      label: 'DD Confirmed',
      value: 'DD Confirmed',
    },
    {
      label: 'Extend Permit Date',
      value: 'Extend Permit Date',
    },
    {
      label: 'Submit LRRP Documentation',
      value: 'Submit LRRP Documentation',
    },
  ],
  current_activity_status: [
    {
      label: 'Open',
      value: 'Open',
    },
    {
      label: 'Completed',
      value: 'Completed',
    },
  ],
};

export const timeFilterOptions = [
  {
    key: 'Today',
    value: 'Today',
  },
  {
    key: 'Yesterday',
    value: 'Yesterday',
  },
  {
    key: 'Tomorrow',
    value: 'Tomorrow',
  },
  {
    key: 'This week',
    value: 'This Week',
  },
  {
    key: 'This month',
    value: 'This Month',
    custom: 'monthWeekField',
  },
  {
    key: 'This year',
    value: 'This Year',
  },
  {
    key: 'This Quarter',
    value: 'This Quarter',
  },
  {
    key: 'Last Year',
    value: 'Last Year',
  },
  {
    key: 'Last 3 days',
    value: 'Last 3 days',
  },
  {
    key: 'Last 7 days',
    value: 'Last 7 days',
  },
  {
    key: 'Last 14 days',
    value: 'Last 14 days',
  },
  {
    key: 'Last 30 days',
    value: 'Last 30 days',
  },
  {
    key: 'Last 365 days',
    value: 'Last 365 days',
  },
  {
    key: 'Last week',
    value: 'Last Week',
  },
  {
    key: 'Last month',
    value: 'Last Month',
    custom: 'monthWeekField',
  },
  {
    key: 'Last quarter',
    value: 'Last Quarter',
  },
  {
    key: 'Last 100000 days',
    value: 'Till Today',
  },
  {
    key: 'From last 365 days to now',
    value: 'From 365 days ago to now',
  },
  {
    key: 'Next 365 days',
    value: 'Next 365 days',
  },
  {
    key: 'Next 30 days',
    value: 'Next 30 days',
  },
  {
    key: 'Next 14 days',
    value: 'Next 14 days',
  },
  {
    key: 'Next 7 days',
    value: 'Next 7 days',
  },
  {
    key: 'Next 3 days',
    value: 'Next 3 days',
  },
  {
    key: 'Next week',
    value: 'Next Week',
  },
  {
    key: 'From now to 5 days from now',
    value: 'Within 5 Days',
  },
  {
    key: 'From now to 3 days from now',
    value: 'Within 3 Days',
  },
  {
    key: 'Next x days',
    value: 'Next X Days',
    custom: 'daysField',
  },
  {
    key: 'Last x days',
    value: 'Last X Days',
    custom: 'daysField',
  },
  {
    key: 'Empty',
    value: 'null',
    custom: 'nullField',
  },
  {
    key: 'custom',
    value: 'Custom',
    custom: 'datePicker',
  },
  {
    key: 'inDateRange',
    value: 'In Date Range',
    custom: 'datePicker',
  },
];

export const monthWeekFilterOptions = [
  {
    key: 'Week 1',
    value: 'Week 1',
  },
  {
    key: 'Week 2',
    value: 'Week 2',
  },
  {
    key: 'Week 3',
    value: 'Week 3',
  },
  {
    key: 'Week 4',
    value: 'Week 4',
  },
  {
    key: 'Week 5(if applicable)',
    value: 'Week 5(if applicable)',
  },
  {
    key: 'Week 6(if applicable)',
    value: 'Week 6(if applicable)',
  },
  {
    key: 'Last Week',
    value: 'Last Week',
  },
  {
    key: '2nd Last Week',
    value: '2nd Last Week',
  },
  {
    key: 'First Half Month(1-15)',
    value: 'First Half Month(1-15)',
  },
  {
    key: 'Second Half Month(16-Last Day)',
    value: 'Second Half Month(16-Last Day)',
  },
];

export const LEAD_RESPONSE_REASON = [
  'Not disrupting 6 sq ft interior or 20 sq feet exterior',
  'Tested Lead Negative',
  'Tested Lead Positive',
  'Written Determination',
  'Home is not pre-1978',
  'Presumed Lead',
  'No Paint Disturbed',
  'Other',
];
export const LEAD_RESPONSE_REASON_BETA = [
  'Not disrupting 6 sq ft interior or 20 sq feet exterior',
  'Tested Lead Negative',
  'Tested Lead Positive',
  'Written Determination',
  'Home is not pre-1978',
  'Presumed Lead',
  'No Paint Disturbed',
  'Other',
];

export const leadResponseReasonInstructionBeta =
  'Please select a reason for the lead response.';

export const lrrpChecklistTitleBeta =
  "Lowe's Installer LRRP Checklist for Renovations";

export const lrrpChecklistSubtitleBeta =
  'Performed in Pre-1978 Housing and Child-Occupied Facilities';

export const lrrpChecklistPurposeTextBeta =
  'The purpose of this form is to document compliance with the U.S. Environmental Protection Agency\'s Lead Renovation, Repair, and Painting Rule ("RRP Rule"), 40 C.F.R. § 745.80, et seq., or any applicable U.S. EPA-authorized state or tribal program regulating lead-based paint safe work practices.';

export const compliantKitUsedLabelBeta =
  'Were EPA or applicable state-recognized lead test kits used by the certified renovator on each and every component (for example, each window to be replaced must be tested unless it is assumed to have lead-based paint) to determine whether lead was present on components affected by renovation?';

export const compliantKitUsedNaValueBeta =
  'N/A, the presence of lead-based paint is presumed';

export const shouldShowLeadTestKitsBeta = value =>
  value === 'yes' || value === compliantKitUsedNaValueBeta;

export const leadTestKitInstructionBeta =
  'Identify kits used and describe components tested, sampling locations and results below. Follow the lead test kit directions completely when testing components. Document paint chip sampling and laboratory results.';

export const installerCertificationAcknowledgementTextBeta =
  'I, the undersigned renovator, certify under penalty of law that the above information is true and complete, and do hereby certify that I have complied with all requirements of the Lead Renovation, Repair, and Painting Rule ("RRP RULE"), 40 C.F.R. § 745.80, et seq., or any applicable state laws or program regulating lead-based paint safe work practices, including compliance with all information distribution, notice requirements and work practice standards in performing this Renovation Project. I certify that I have provided the Customer with all documentation required to be supplied under the RRP Rule or state program, shall retain all records required by law for at least 3 years or longer if required by state law, and shall provide copies of all the records required to be retained by the RRP Rule or applicable state program upon request. If requested by the Customer, I have provided the Customer with a completed copy of this LRRP Checklist.';

export const notificationConfirmationValue = [
  'Receipt acknowledged',
  'Certificate of mail',
  'Certificate attempted delivery',
];

export const notificationConfirmationLabelBeta =
  '1. Please describe how you provided owners, adult occupants (if not owner-occupied), and/or adult representatives of child-occupied facilities with the Renovate Right pamphlet.';

export const notificationConfirmationValueBeta = [
  {
    label:
      'Signed and dated acknowledgements of the receipt of Renovate Right pamphlet.',
    value: 'Receipt acknowledged',
  },
  {
    label: 'Certificates of mailing the Renovate Right pamphlet.',
    value: 'Certificate of mail',
  },
  {
    label:
      'Certificates of attempted delivery of the renovator right pamphlet (for non-owner adult occupants only)',
    value: 'Certificate attempted delivery',
  },
];

export const commonAreaLabelBeta =
  '2. If the Renovation Project involved a common area of a multi-unit housing building, was a signed statement describing the steps performed to notify all occupants of multi-unit housing of the renovation activities, to provide the Renovate Right pamphlet to all occupants and to inform of any changes to the renovation activities obtained and on file?';

export const childOccupiedFacilityLabelBeta =
  '3. If the Renovation Project was performed in a child-occupied facility, was a signed statement describing the steps performed to notify all parents and guardians of children using child-occupied facilities of the renovation activities, to provide the Renovate Right pamphlet, and to provide a copy of the records showing compliance with the LRRP Rule and any dust clearance sampling reports, obtained and on file?';

export const technicianNamesLabelBeta =
  '4. List any dust sampling technicians, inspectors, or risk assessors, if used:';

export const trainingAreasProvidedLabelBeta =
  '5. If applicable, select the areas in which training was provided to other workers.';

export const trainingAreasProvidedValueBeta = [
  {
    label: 'Posting warning signs',
    value: 'POSTING_WARNING_SIGN',
  },
  {
    label: 'Maintaining containment',
    value: 'MAINTAINING_CONTAINMENT',
  },
  {
    label: 'Waste handling',
    value: 'WASTE_HANDLING',
  },
  {
    label: 'Setting up plastic containment barriers',
    value: 'CONTAINMENT_BARRIERS',
  },
  {
    label: 'Avoiding spread of dust to adjacent areas',
    value: 'AVOIDING_DUST_SPREAD',
  },
  {
    label: 'Post-renovation cleaning',
    value: 'POST_RENOVATION_CLEANING',
  },
];

export const traineeNamesLabelBeta = '6. List names of workers trained:';

export const workAreaSignageLabelBeta =
  '7. Did you post signs defining the work area and warning signs at the entrance of the work area?';

export const workAreasContainedLabelBeta =
  '8. Select all applicable areas contained to prevent the spread of dust and debris.';

export const prohibitedPracticesLabelBeta =
  'None of the prohibited and restricted work practices were employed.';

export const wasteContainedLabelBeta =
  'Waste was contained on site and while being transported off-site.';

export const wasteContainedDetailsBeta = [
  'All chips and debris were picked up, protective sheeting misted, folded dirty side inward, and taped for removal.',
  'Plastic sheeting misted, folded dirty side inward, and taped for removal.',
  'Work area surfaces, walls and objects were cleaned using HEPA vacuum and/or wet cloths or mops (interiors).',
];

export const worksiteProperlyCleanedLabelBeta =
  'The work site was properly cleaned after renovation. Including but not limited to:';

export const postRenovationCleaningLabelBeta =
  '10. Please indicate how you verified post-renovation cleaning.';

export const postRenovationCleaningOptionsBeta = [
  {
    label: 'Cleaning verification',
    selectedLabel: 'Cleaning verification',
    value: 'Cleaning verification',
  },
  {
    label:
      'Dust clearance testing was performed instead of cleaning verification. The sample results were below clearance stands, and a copy of the report was provided to property owners, adult occupants (if not owner-occupied) and/or adult representatives of child-occupied facilities and posted in common areas of multi-unit housing',
    selectedLabel: 'Dust clearance testing was performed',
    value: 'Dust clearance',
  },
];

export const emergencyRenovationExplanationLabelBeta =
  '11. If the renovation is an emergency renovation under the LRRP Rule, describe the nature of the emergency and document the provisions of the LRRP rule(s) that were not followed:';

export const workAreasContainedValue = [
  'Objects removed or covered',
  'HVAC ducts closed and covered',
  'Windows and doors closed and sealed',
  'Floor surfaces covered 6ft beyond work area',
  'Doors closed and sealed',
  'Doors used were covered',
  'Work area floors covered',
  'Windows within 20 ft closed',
  'Doors within 20 ft closed and sealed',
  'Exterior ground properly covered',
  'Vertical containment installed',
];

export const workAreasContainedValueBeta = [
  'Objects removed or covered',
  'HVAC ducts closed and covered',
  'Windows and doors closed and sealed',
  'Floor surface covered 6ft beyond work area',
  'Doors closed and sealed',
  'Doors used were covered',
  'Work area floors covered',
  'Windows within 20 ft closed',
  'Doors within 20 ft closed and sealed',
  'Exterior ground properly covered',
  'Vertical containment installed',
];

export const workAreasContainedGroupedValueBeta = [
  {
    label: 'Interior',
    items: [
      {
        label: 'All objects in the work area were removed or covered',
        value: 'Objects removed or covered',
      },
      {
        label: 'HVAC ducts in the work area were closed and covered',
        value: 'HVAC ducts closed and covered',
      },
      {
        label: 'Windows and doors in the work area were closed and sealed',
        value: 'Windows and doors closed and sealed',
      },
      {
        label:
          'Floor surfaces covered by plastic extending 6 feet from work area',
        value: 'Floor surface covered 6ft beyond work area',
      },
      {
        label: 'Doors in the work area were closed and sealed',
        value: 'Doors closed and sealed',
      },
      {
        label:
          'Doors that must be used in the work area were covered to allow passage but prevent spread of dust',
        value: 'Doors used were covered',
      },
      {
        label: 'Floors in the work area were covered with taped-down plastic',
        value: 'Work area floors covered',
      },
    ],
  },
  {
    label: 'Exterior',
    items: [
      {
        label: 'Windows in and within 20 feet of the work area were closed',
        value: 'Windows within 20 ft closed',
      },
      {
        label:
          'Doors in and within 20 feet of the work area were closed and sealed',
        value: 'Doors within 20 ft closed and sealed',
      },
      {
        label:
          'Ground was covered by plastic extending 10 feet from work area - plastic anchored to building and weighed down by heavy objects',
        value: 'Exterior ground properly covered',
      },
      {
        label:
          'If necessary, vertical containment was installed if property line prevents 10 feet of plastic ground cover, or if necessary to prevent migration of dust and debris to adjacent property',
        value: 'Vertical containment installed',
      },
    ],
  },
];

export const PROJECT_TIER_DROPDOWN = [
  'Detail / Work Order',
  'Team Install',
  'Detail',
  'Tier 1',
  'Tier 2',
  'dishwasher',
  'otr microwave',
  'simple vent hood',
  'toilet',
  'ceiling fan',
  'light fixture',
  'work order',
  'single vanity',
  'sink disconnect/reconnect',
  'garbage disposal',
  'faucet',
  'cooktop',
  'shower door',
  'wall oven',
  'gas range',
  'gas dryer',
  'double vanity',
  'complex vent',
];

export const TEXT_COLOR_BLACK = '#000';

export const PROJECT_TYPES = {
  INSTALLATION: 'Installation',
  MEASUREMENT: 'Measurement',
  WORK_ORDER: 'Work Order',
  TENTATIVE_SCHEDULE: 'Tentative Schedule',
  SCHEDULE: 'Schedule',
  UNASSIGNED_INSTALLER: 'Unassigned Installer',
  ADDITIONAL_SCHEDULE: 'Additional Schedule',
  QUOTE: 'Quote',
  CX_SCHEDULED_STATUS: 'Customer Scheduled',
  CX_RESCHEDULED_STATUS: 'Customer Rescheduled',
  CX_SCHEDULED_REJECTED_STATUS: 'Customer Scheduled Rejected',
  SCHEDULED: 'Scheduled',
  BUSTED: 'Busted',
};

export const ALLOWED_TYPES_FOR_NEED_SUPPORT_TAB = [
  'Measurement',
  'Installation',
  'Work Order',
];

export const NEEDS_SUPPORT_CATEGORIES = {
  MEASUREMENT: ['Refunds', 'Customers'],
  INSTALLATION: [
    'Labor',
    'Products',
    'Refunds',
    'Missing Documents',
    'Customers',
    'Permits',
  ],
  WORK_ORDER: [
    'Labor',
    'Products',
    'Refunds',
    'Missing Documents',
    'Customers',
    'Permits',
  ],
};

export const NEEDS_SUPPORT_LABELS = {
  PRODUCTS: 'Products',
  LABOR: 'Labor',
  REFUNDS: 'Refunds',
  MISSING_DOCUMENTS: 'Missing Documents',
  CUSTOMERS: 'Customers',
  PERMITS: 'Permits',
  DAMAGED_PRODUCT: 'Damaged product',
  PRODUCT_NOT_READY_AT_JOBSITE: 'Product not ready at jobsite',
  PRODUCT_NOT_READY_AT_STORE: 'Product not ready at store',
  MISSING_OR_INCORRECT_PRODUCT: 'Missing or incorrect product',
  NO_PRODUCT_ATTACHED: 'No product attached',
};

export const NEEDS_SUPPORT_TYPES = {
  PRODUCTS: [
    'Missing or incorrect product',
    'Damaged product',
    'Product not ready at jobsite',
    'Product not ready at store',
    'No product attached',
  ],
  LABOR: ['Mileage', 'Trip Fee', 'Missing or incorrect labor'],
  REFUNDS: ['Full refund', 'Partial refund', 'Permit refund'],
  MISSING_DOCUMENTS: [
    'Provide designs',
    'Provide proposals',
    'Provide contract',
  ],
  CUSTOMERS: ['Unable to contact customer', 'Incorrect contact information'],
  PERMITS: ['Add permit'],
};

export const NEED_SUPPORT_PAYMENT_TYPE = {
  DAMAGED_PRODUCT: ['Trip Fee', 'Wait Fee', 'Both trip and wait fees', 'None'],
  PRODUCT_NOT_READY_AT_JOBSITE: ['Trip Fee'],
  PRODUCT_NOT_READY_AT_STORE: [
    'Trip Fee',
    'Wait Fee',
    'Both trip and wait fees',
    'None',
  ],
  MISSING_OR_INCORRECT_PRODUCT: [
    'Trip Fee',
    'Wait Fee',
    'Both trip and wait fees',
    'None',
  ],
  NO_PRODUCT_ATTACHED: ['Trip Fee', 'None'],
};
export const DEFAULT_COLORS_BY_PROJECT_TYPE =
  clientDetails?.project_type_color_config || {};

export const CONFIG = {
  ENABLE_CUSTOMER_LIST: REACT_APP_ENABLE_CUSTOMER_LIST,
  API_BASE_URL: URL_CONSTANTS.API.BASE_URL,
  GOOGLE_MAP_KEY: REACT_APP_GOOGLE_MAPS_KEY,
  API_CRM_URL: URL_CONSTANTS.CRM.baseUrl,
  API_PROJECT_URL: URL_CONSTANTS.PROJECTS.baseUrl,
  API_INVENTORY_URL: URL_CONSTANTS.INVENTORY.baseUrl,
};

export const DOCUMENT_PHOTO_TYPE = {
  DOCUMENT: 1,
  PHOTO: 3,
  VIDEO: 4,
};

export const DISTANCE_UNIT_OPTIONS = [
  { id: 'miles', label: 'Miles' },
  { id: 'kms', label: 'KMs' },
];

export const USER_STATUS_OPTIONS = [
  { statusIds: 18, label: 'Active' },
  { statusIds: 19, label: 'Inactive' },
];

export const HD_DOC_NUMBERS_FOR_DOCUMENTS = [
  { id: 100, name: 'Measure' },
  { id: 105, name: '105 Receipt of Lead Safe Pamphlet' },
  { id: 300, name: '300 Install Worksheet' },
  { id: 500, name: '500 Install Inspection' },
  { id: 650, name: '650 Customer Approval (ICA)' },
  { id: 651, name: '651 Customer Agreement (HIA)' },
  { id: 652, name: '652 Warranty' },
  { id: 653, name: '653 Collections' },
  { id: 750, name: '750 Change Order' },
  { id: 753, name: '753 Permit' },
  { id: 801, name: '801 LSWP Lead Safe Form (HS-105)' },
  { id: 802, name: '802 LSWP Acknowledgement of Notification (HS-111)' },
  { id: 803, name: '803 LSWP Acknowledgement of Remediation (HS-112)' },
  { id: 804, name: '804 LSWP Renovation Acknowledgement (HS-115)' },
  { id: 805, name: '805 LSWP Renovation Notice (HS-116)' },
  { id: 806, name: '806 LSWP Tenant Notification (HS-117)' },
  { id: 807, name: '807 LSWP RRP Rule (HS-118)' },
  { id: 808, name: '808 LSWP Pre-Existing Conditions (HS-119)' },
  { id: 810, name: '810 LSWP Release and Covenant Pre-Services Work (HS-121)' },
  { id: 811, name: '811 LSWP Release and Covenant Pre-Existing Lead (HS-122)' },
  { id: 812, name: '812 LSWP Project Notification' },
  { id: 813, name: '813 LSWP Area Drawing (Non-Actionable)' },
  { id: 814, name: '814 LSWP House Built Verification' },
  { id: 815, name: '815 LSWP Lead Free Certification Statement Copy' },
  { id: 951, name: '951 Tax Forms' },
  { id: 999, name: '999 Others' },
];

export const HD_DOC_NUMBERS_FOR_PHOTOS = [
  { id: 100, name: 'Measure' },
  { id: 954, name: 'Site Photo' },
];

export const SOURCE_SYSTEMS = {
  LOWES: 1,
  HOME_DEPOT: 2,
  LUMBER_LIQUIDATOR: 3,
};

export const SOURCE_STATUS = {
  OPEN: 'Open',
  CLOSED: 'Closed',
};

export const HD_CATEGORY = {
  BLINDS: 'Blinds',
};

export const VIEW_NOTE_TYPES = [
  {
    note_category_id: 1,
    category_name: 'Installer',
  },
  {
    note_category_id: 2,
    category_name: 'Retailer',
  },
  {
    note_category_id: 3,
    category_name: 'Store',
  },
  {
    note_category_id: 4,
    category_name: 'Internal ',
  },
  {
    note_category_id: 5,
    category_name: 'Item',
  },
  {
    note_category_id: 6,
    category_name: 'Reschedule',
  },
  {
    note_category_id: 7,
    category_name: 'Busted',
  },
  {
    note_category_id: 8,
    category_name: 'Pinned',
  },
  {
    note_category_id: 25,
    category_name: 'Delivery',
  },
  {
    note_category_id: 24,
    category_name: 'Delivery Complete',
  },
  {
    note_category_id: 51,
    category_name: 'Important Installer Note',
  },
  {
    note_category_id: 50,
    category_name: 'Important Scheduler Note',
  },
];

export const LL_DOC_TYPE_FOR_PHOTOS = [
  { label: 'InstallPhotos', value: 'InstallPhotos' },
  { label: 'MeasurePhotos', value: 'MeasurePhotos' },
];

export const LL_DOC_TYPE_FOR_DOCUMENTS = [
  { label: 'All_Doc_WITH_CO', value: 'All_Doc_WITH_CO' },
  { label: 'All_Doc_WITO_CO', value: 'All_Doc_WITO_CO' },
  { label: 'CustCompletion', value: 'CustCompletion' },
  { label: 'InstallChangeAuth', value: 'InstallChangeAuth' },
  { label: 'InstLienWaiver', value: 'InstLienWaiver' },
  { label: 'InstWorkOrder', value: 'InstWorkOrder' },
  { label: 'Invoice', value: 'Invoice' },
  { label: 'LeadSafe', value: 'LeadSafe' },
  { label: 'MoistureReading', value: 'MoistureReading' },
  { label: 'IPProjectAssess', value: 'IPProjectAssess' },
  { label: 'The Satisfaction Form', value: 'The Satisfaction Form' },
];

export const PRIMARY_COLOR = '#454cb2';
export const PF_ADMIN = REACT_APP_PF_ADMIN_ID;

export const scheduleInfoUserSkipAction = 'skip';
export const scheduleInfoUserWipeAction = 'delete';
export const scheduleInfoUserFillAction = 'fill';
export const scheduleInfoUserCustomAction = 'custom';
export const ProjectFields = {
  PROJECT_LEAD_TEST_REQ: 'project__lead_test_req',
  PROJECT_HD_LEAD_TEST_RESULT: 'project__hd_lead_test_result',
  PROJECT_EPA_LEAD_CONFIGURATION: 'project__epa_lead_configuration',
  LABOR_AMOUNT: 'projectInstaller__labor_amount',
  PROJECT_ESTIMATED_LABOR_AMOUNT: 'project__estimated_labour_amount',
  PROJECT_DOCUMENT_IS_SIGNED: 'projectDocument__is_signed',
  PROJECT_DOCUMENT_NAME: 'projectDocument__document_name',
  PROJECT_DOCUMENT_TYPE_NAME: 'projectDocument__type_name',
  PROJECT_DOCUMENT_CATEGORY_NAME: 'projectDocument__category_name',
  PROJECT_DOCUMENT_IS_INSTALLER_VISIBILITY:
    'projectDocument__is_installer_visibility',
  PROJECT_DOCUMENT_IS_PROJ_DOCU_VISIBILITY:
    'projectDocument__is_proj_docu_visibility',
  PROJECT_DOCUMENT_IS_CUSTOMER_VISIBLE: 'projectDocument__is_customer_visible',
  PROJECT_DOCUMENT_REVIEWED_BY: 'projectDocument__reviewed_by',
  PROJECT_DOCUMENT_REVIEWED_AT: 'projectDocument__reviewed_at',
  PROJECT_DOCUMENT_CREATED_BY: 'projectDocument__created_by',
  PROJECT_DOCUMENT_CREATED_AT: 'projectDocument__created_at',
  PROJECT_DOCUMENT_STORE_TYPE: 'projectDocument__document_store_type',
  PROJECT_DOCUMENT_IS_REL_PROJ_DOCU_VISIBILITY:
    'projectDocument__is_rel_proj_docu_visibility',
  PROJECT_DOCUMENT_IS_SIGNATURE_REQUIRED:
    'projectDocument__is_signature_required',
  PROJECT_DOCUMENT_HD_DOC_NUMBER: 'projectDocument__hd_doc_cd_number',
  PROJECT_DOCUMENT_EDITABLE: 'projectDocument__is_editable',
  PROJECT_DOCUMENT_SMS_SENT: 'projectDocument__get_sms',
};
export const DATE_OPERATORS = {
  TODAY: 'Today',
  YESTERDAY: 'Yesterday',
  TOMORROW: 'Tomorrow',
  THIS_WEEK: 'This week',
  THIS_MONTH: 'This month',
  THIS_YEAR: 'This year',
  LAST_YEAR: 'Last Year',
  TILL_TODAY: 'Till today',
  FROM_365_DAYS_TO_NOW: 'From last 365 days to now',
  THIS_QUARTER: 'This Quarter',
};

export const scheduleInfoUserAction = {
  FULL_ALLOCATION_ITEMS: 'delete',
  ALLOCATE_REMAINING_ITEMS: 'fill',
  LEAVE_UNASSIGNED_ITEMS: 'skip',
  CUSTOM_ALLOCATION: 'custom',
};

export const RetainageFrequencyTypeOptions = [
  {
    key: 'daily',
    value: 'Daily',
  },
  {
    key: 'weekly',
    value: 'Weekly',
  },
  {
    key: 'bi_weekly',
    value: 'Bi-Weekly',
  },
  {
    key: 'monthly',
    value: 'Monthly',
  },
  {
    key: 'yearly',
    value: 'Yearly',
  },
];

export const postRenovationCleaningMethod = [
  'Cleaning verification',
  'Dust clearance',
];

export const postRenovationCleaningMethodBeta = [
  'Cleaning verification',
  'Dust clearance',
];

export const nonAvailableReason = 'N/A';

export const nonAvailableReasonBeta = 'N/A';

export const PROJECT_TYPE = {
  MEASUREMENT: 1,
  INSTALLATION: 2,
  WORKORDER: 3,
};

export const COMMISSION_WORK_TYPE = {
  ID: 25,
  LABEL: 'Commission',
};

export const LL_INVOICE_STATUS_TYPE = [
  { status: 'not_invoiced', value: 'Not Invoiced' },
  { status: 'invoice_sent', value: 'Invoice Sent' },
];

// Options for Payout type
export const RETAINAGE_PAYOUT_TYPE_OPTION = [
  {
    key: 'fixed',
    value: 'Fixed',
  },
  {
    key: 'percentage',
    value: 'Percentage',
  },
  {
    key: 'payrollPercentage',
    value: 'Percentage of Payroll',
  },
];

// Options for Payout type
export const CHARGEBACK_PAYOUT_TYPE_OPTION = [
  ...RETAINAGE_PAYOUT_TYPE_OPTION,
  {
    key: 'collectFromRetainage',
    value: 'Collect from Retainage',
  },
];

export const CHARGEBACK_TYPE = {
  PayrollOfPercentage: 'Percentage of Payroll',
};

export const ENVIRONMENT_VARIABLES = {
  auditTabEnabled: REACT_APP_AUDIT_TAB_ENABLED,
  configAuditTabEnabled: REACT_APP_CONFIGURATION_AUDIT_LOG_ENABLED,
};

export const DEFAULT_AUDIT_LOG_SUBMODULE_ID = 6;
export const AUDIT_LOG_SYSTEM_DEFAULT_REPORT = 63;

// Options for Date Criteria
export const DateCriteria = [
  {
    key: 'scheduled',
    value: 'Scheduled',
  },
  {
    key: 'invoiced',
    value: 'Invoiced',
  },
  {
    key: 'projectCompletion',
    value: 'Project Completion',
  },
  {
    key: 'lineItemCompletion',
    value: 'Line Item Completion',
  },
];

export const projectUserStatusId = 255;
export const SALES_COMMISSION_TYPE = [
  { label: 'Total Retail $', value: 'Total Retail $' },
  { label: 'Total Revenue $', value: 'Total Revenue $' },
  { label: 'Total Cost $', value: 'Total Cost $' },
  { label: 'Labor Retail $', value: 'Labor Retail $' },
  { label: 'Total Sales $', value: 'Total Sales $' },
  { label: 'Overall Profit $', value: 'Overall Profit $' },
  { label: 'Overall Margin %', value: 'Overall Margin %' },
];

export const ROLE_EDIT_DISABLE_ID = [1, 2, 3];

export const ESTIMATED_MAX_LIMIT = 1000000;

export const PayrollType = ['labor', 'chargeback', 'retainage'];

export const PayrollFooters = [
  { key: 'projFooter', label: 'Project: Total' },
  { key: 'approvedFooter', label: 'Project: Approved' },
  { key: 'excludeFooter', label: 'Project: Exclude' },
  { key: 'balanceFooter', label: 'Project: Balance' },
  { key: 'exportFooter', label: 'Project: Export' },
];

// Options for Payroll paid unpaid
export const PayrollReviewType = ['paid', 'unpaid'];

export const ItemLinkageConfigOptions = [
  { name: 'Sync Technician', value: 'technician' },
  { name: 'Sync Scheduled Date & Time', value: 'schedule' },
  { name: 'Sync Documents', value: 'documents' },
  { name: 'Complete', value: 'complete' },
  { name: 'Internal Status', value: 'internal_status' },
  { name: 'EPA Lead Details', value: 'epa_lead' },
  { name: 'Installer Notes', value: 'installer_notes' },
  { name: 'Retailer Notes', value: 'retailer_notes' },
  {
    name: 'Project Item Technician Allocation',
    value: 'project_item_technician_allocation',
  },
];

export const project_linkages = {
  options: [],
  force_sync: false,
  enabled: false,
};

export const active_jobs_statuses = {
  options: [],
  enabled: false,
};
// Options for Payroll records
export const PayrollRecordType = ['excluded', 'unexcluded'];
export const PayrollFinalExportType = ['export', 'unexport'];

export const ExportedReportsStatus = [
  { key: 'ACTIVE', className: 'text-blue-400' },
  { key: 'INACTIVE', className: 'text-600' },
  { key: 'INPROGRESS', className: 'text-yellow-400' },
  { key: 'DONE', className: 'text-green-400' },
  { key: 'FAILED', className: 'text-red-400' },
  { key: 'DELETED', className: 'text-red-400' },
];

export const ReportDateDiff = 14;

export const PayrollReportFilters = [
  { key: 'searchBy', value: 'Search By' },
  { key: 'workroom', value: 'Workroom' },
  { key: 'store', value: 'Store Name' },
  { key: 'category', value: 'Category' },
  { key: 'type', value: 'Type' },
  { key: 'status', value: 'Status' },
  { key: 'technician', value: 'Technician' },
  { key: 'technicianType', value: 'Technician Type' },
  { key: 'chargeback', value: 'Chargeback' },
  { key: 'retainage', value: 'Retainage' },
  { key: 'labor', value: 'Labor' },
  { key: 'exclude', value: 'Exclude' },
  { key: 'paymentStatus', value: 'Approved' },
];
export const libraries = ['places', 'geometry'];

export const DAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
export const WORK_HOURS = [
  {
    day: 'Monday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Tuesday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Wednesday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Thursday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Friday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Saturday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
    is_working: true,
  },
  {
    day: 'Sunday',
    start_time: '08:00',
    end_time: '17:00',
    break_start_time: '12:00',
    break_end_time: '13:00',
  },
];

export const ProjectReviewStatus = {
  REFUNDREVIEWED: 'Refund_Reviewed',
};
export const AddNewColor = {
  ADDNEWCOLOR: 0,
};

export const workTypeConstants = {
  SCHEDULED: 1,
  TENTATIVE_SCHEDULE: 7,
};

export const PermitsStatusTypeId = {
  APPLICATIONSUBMITTED: 137,
};

export const CX_SCHEDULED_STATUS = 'Customer Scheduled';
export const homeDepotOrder = {
  HD_ORDER: 'hd_order',
  SF_AND_I_ORDER: 'sf_and_i_order',
  HD_LEAD: 'hd_lead',
  BLINDS_ORDER: 'blinds_order',
};
export const ImageFormatType = ['image/jpeg', 'image/png', 'image/jpg'];

export const csvUploadConfig = {
  PF_CSV_UPLOAD_SIZE: REACT_APP_PF_CSV_UPLOAD_SIZE || 512000,

  ERROR_MESSAGES: {
    POST_UPLOADED_DATA_SUCCESS: 'File uploaded successfully',
    FILE_TYPE_ERROR: 'Only CSV file are allowed.',
    FILE_SIZE_ERROR: `File size exceeds the maximum limit of ${
      (REACT_APP_PF_CSV_UPLOAD_SIZE || 512000) / 1024
    } KB.`,
    FILE_EXISTS: `File already uploaded.`,
    FILE_NOT_SUPPORTED: `File not supported.`,
  },
};
export const DocFileTypeError = {
  DOC_FILE_TYPE_ERROR:
    'Only .pdf, .doc, .docx, .xls, .xlsx, .csv, and .dxf files are allowed',
  DOC_FILE_LIMIT_ERROR: 'Please select up to 5 files only.',
  DOC_FILE_DXF_SIZE_ERROR: '.dxf files must be less than 5 MB in size.',
};
export const Limit = {
  MAX_LIMIT: 10,
};
export const DateSold = 'Project.date_sold';

export const BULLETIN = {
  TOPBAR: 1,
  HOME: 2,
};
export const ROLES = {
  ADMIN: 'Admin',
  INSTALLER: 'Installer',
  STAFF: 'Staff',
};

export const PERMISSION_TYPES = {
  USER_ASSIGNED: 'user_assigned',
  MODIFY: 'modify',
};

export const EMPLOYMENT_TYPES = [
  { title: 'Employee', value: 'Employee' },
  { title: 'Subcontractor', value: 'Subcontractor' },
  { title: 'Candidate', value: 'Candidate' },
];
export const formAction = {
  ADD: 'add',
  EDIT: 'edit',
  VIEW: 'view',
};

export const projectInfoCategory = {
  ADD_CATEGORY: 'Add New Category',
};

export const INVENTORY = {
  OPTIONS_FOR_ITEM: [
    { id: 1, name: 'Add', value: 'Add' },
    { id: 2, name: 'Lost', value: 'Lost' },
    { id: 3, name: 'Damaged', value: 'Damaged' },
  ],
  OPTIONS_FOR_PROJECT: [
    { id: 1, name: 'Add', value: 'Add' },
    { id: 2, name: 'Lost', value: 'Lost' },
    { id: 3, name: 'Damaged', value: 'Damaged' },
    { id: 6, name: 'Allocated', value: 'Allocated' },
    { id: 7, name: 'On Order', value: 'OnOrder' },
  ],
  OPTIONS_FOR_ADJUSTMENT_TYPE: [
    { id: 1, name: 'Add', value: 'Add' },
    { id: 2, name: 'Lost', value: 'Lost' },
    { id: 3, name: 'Damaged', value: 'Damaged' },
    { id: 5, name: 'Dispatched', value: 'Dispatched' },
    { id: 6, name: 'Allocated', value: 'Allocated' },
    { id: 7, name: 'On Order', value: 'OnOrder' },
  ],
  OPTIONS_FOR_ADJUSTMENT_STOCK: [
    { id: 5, name: 'Dispatched', value: 'Dispatched' },
    { id: 6, name: 'Allocated', value: 'Allocated' },
    { id: 7, name: 'On Order', value: 'OnOrder' },
  ],
};
export const statusData = [{ value: 'Open' }, { value: 'Completed' }];

export const severityData = [
  { name: 'High', icon: 'pi pi-angle-up' },
  { name: 'Medium', icon: 'pi pi-align-justify' },
  { name: 'Low', icon: 'pi pi-angle-down' },
];

export const MAPLINK_BASE = 'https://www.google.com/maps/';
export const TECHNICIAN_FILTER_MESSAGE = `Allocate items using "Full Allocation" for 100% or "Custom Allocation" with your inputs or "Allocate Remaining" for unassigned parts or "Leave Unassigned".`;

export const ALLOCATION_PROJECT_ITEMS = [
  'FULL_ALLOCATION_ITEMS',
  'CUSTOM_ALLOCATION',
  'ALLOCATE_REMAINING_ITEMS',
  'LEAVE_UNASSIGNED_ITEMS',
];

export const SchedulerCustomFilters = {
  CUSTOMTYPE: 'AC',
  ADMIN: 'configuration',
  USER: 'usermanagement',
};
export const PROJECT_REPORT = {
  CUSTOMERS: 'customers',
  WORKROOMID: 'workroomId',
  CALENDAR: 'calendar',
  SPLIT: 'split',
  FULL_CALENDAR: 'fullCalendar',
  CONTAINED: 'contained',
  MAP: 'map',
  PROJECT: 'Project',
  CATEGORY: 'category',
  HORIZONTALVIEW: 'horitzonalview',
};

export const SCHEDULER_MAP = [
  { name: 'Map', value: 'ROADMAP' },
  { name: 'Satellite', value: 'SATELLITE' },
];

export const CHARGEBACK_DEFAULT_STATUS = {
  status_id: [426, 424, 346, 347, 345, 343, 425, 344, 458],
};

export const JOB_STATUS = {
  SCHEDULED: 'Scheduled',
};
export const INPUT_NUMBER_LOCALE = 'en-US';

export const UNASSIGNED = {
  UNASSIGNED: 'unassigned',
};
export const TECHNICIAN_TYPES = {
  SCHEDULED: 'schedule',
};

export const ITEM_TYPES = {
  labor: 2,
  product: 6,
};

export const ParentItemFilterOptions = [
  { label: 'All Parent', value: 'is_parent' },
  { label: 'All Child', value: 'is_child' },
];

export const openDocumentInfo = {
  is_offline: false,
  count: 1,
  device_id: '',
  platform: 'web',
};

export const DELIVERY_STATUS = 1;

export const DOCUMENT_AUTO_PULL_RETRY_FIELDS = {
  options: [],
  enabled: 0,
};
export const COVERAGE_TYPE_OPTIONS = [
  { label: 'Stores', value: 1 },
  { label: 'Workroom', value: 2 },
  { label: 'District', value: 3 },
];
export const COVERAGE_TYPES = {
  STORE: 'Stores',
  WORKROOM: 'Workroom',
  DISTRICT: 'District',
};
export const dateFilters = [
  {
    key: 'Project.date_scheduled_start',
    value: ['dateScheduledFilterStart', 'dateScheduledFilterEnd'],
  },
  {
    key: 'Project.completion_date',
    value: ['dateCompletionFilterStart', 'dateCompletionFilterEnd'],
  },
  {
    key: 'PaymentRequest.check_date',
    value: ['checkDateFromFilter', 'checkDateToFilter'],
  },
  {
    key: 'Project.date_sold',
    value: ['dateSoldFromFilter', 'dateSoldToFilter'],
  },
];

export const globalFilters = [
  {
    key: 'Project.store_number',
    value: ['stores', 'store_number'],
  },
  {
    key: 'Project.project_category_id',
    value: ['projectCategories', 'project_category_id'],
  },
  {
    key: 'Project.project_type_id',
    value: ['projectTypes', 'project_type_id'],
  },
  {
    key: 'Project.status_id',
    value: ['projectStatus', 'status_id'],
  },
  {
    key: 'Project.workroom_type',
    value: ['projectWorkrooms', 'label'],
  },
  {
    key: 'InstallerDetail.installer_id',
    value: ['techniciansVal', 'installer_id'],
  },
  {
    key: 'InstallerDetail.installer_company_id',
    value: ['company', 'company_id'],
  },
  {
    key: 'Project.store_district',
    value: ['districtId', 'districtId'],
  },
  {
    key: 'UserMeta.user_type_id',
    value: ['userType', 'user_type_id'],
  },
  {
    key: 'Project.territory_id',
    value: ['territory', 'territory_id'],
  },
];

export const globalDashboardDefaultFilters = [
  {
    key: 'Project.store_number',
    value: 'storeNumber',
  },
  {
    key: 'Project.project_category_id',
    value: 'projectCategoryId',
  },
  {
    key: 'Project.project_type_id',
    value: 'projectTypeId',
  },
  {
    key: 'Project.status_id',
    value: 'statusId',
  },
  {
    key: 'Project.workroom_type',
    value: 'dashboardWorkroom',
  },
  {
    key: 'InstallerDetail.installer_id',
    value: 'newInstallerIds',
  },
  {
    key: 'InstallerDetail.installer_company_id',
    value: 'companyIds',
  },
];

export const globalRtsReportFilters = [
  {
    key: 'customers',
    value: ['customerId', 'id'],
  },
  {
    key: 'stores',
    value: ['storeNumber', 'store_number'],
  },
  {
    key: 'projectCategories',
    value: ['projectCategoryId', 'project_category_id'],
  },
  {
    key: 'projectTypes',
    value: ['projectTypeId', 'project_type_id'],
  },
  {
    key: 'projectStatus',
    value: ['statusId', 'status_id'],
  },
  {
    key: 'projectWorkrooms',
    value: ['workroomId', 'type_id'],
  },
  {
    key: 'sourceStatus',
    value: ['imsStatus', 'status_id'],
  },
  {
    key: 'districtId',
    value: ['districtId', 'districtId'],
  },
  {
    key: 'territory',
    value: ['territoryIds', 'territory_id'],
  },
  {
    key: 'userCategory',
    value: ['userCategoryIds', 'user_category_id'],
  },
  {
    key: 'userSkillLevel',
    value: ['userSkillLevelIds', 'user_skill_level_id'],
  },
];

export const globalCalendarFilters = [
  {
    key: 'stores',
    value: ['projectStoreId', 'store_id'],
  },
  {
    key: 'projectCategories',
    value: ['projectCategoryId', 'project_category_id'],
  },
  {
    key: 'projectTypes',
    value: ['projectTypeIds', 'project_type_id'],
  },
  {
    key: 'projectWorkrooms',
    value: ['workRoomIds', 'type_id'],
  },
  {
    key: 'districtId',
    value: ['districts', 'districtId'],
  },
  {
    key: 'techniciansVal',
    value: ['installerIds', 'user_id'],
  },
  {
    key: 'userType',
    value: ['userTypeIds', 'user_type_id'],
  },
  {
    key: 'userCategory',
    value: ['userCategoryIds', 'user_category_id'],
  },
  {
    key: 'userSkillLevel',
    value: ['userSkillLevelIds', 'user_skill_level_id'],
  },
  {
    key: 'newInstallerUserIds',
    value: ['newInstallerUserIds', 'user_id'],
  },
  {
    key: 'territory',
    value: ['territoryIds', 'territory_id'],
  },
  {
    key: 'company',
    value: ['companyIds', 'company_id'],
  },
];

export const globalDefaultCalendarFilters = [
  {
    key: 'projectCategoryId',
    value: 'projectCategoryId',
  },
  {
    key: 'projectTypeId',
    value: 'projectTypeIds',
  },
  {
    key: 'workroomId',
    value: 'workRoomIds',
  },
  {
    key: 'districtId',
    value: 'districts',
  },
  {
    key: 'calendarStoreIds',
    value: 'projectStoreId',
  },
  {
    key: 'newInstallerUserIds',
    value: 'installerIds',
  },
  {
    key: 'companyIds',
    value: 'companyIds',
  },
];

export const PROJECT_STATUS_ID = {
  waiting_for_product: 5,
  ON_HOLD_PENDING_CANCEL: 237,
  CANCELLED: 4,
  CLOSED: 8,
  REJECTED: 9,
  COMPLETED: 10,
  REFUNDED: 11,
  REASSIGNED: 114,
};
export const ORDER_COMPLETION_VALIDATION_FIELDS = {
  enabled: 0,
};

export const PICK_UP_LOCATION_ID = [1, 2, 3, 4];
export const IS_WAREHOUSE_ID = [1, 5, 6, 7];
export const PICK_ID_FOR_VALIDATION = [1, 4, 5, 6, 7];
export const PICK_UP_LOCATION = {
  WAREHOUSE: 'Warehouse',
  STORE: 'Store',
  CUSTOMER: 'Customer',
};
export const DOCUMENT = {
  DOCUMENT_SOURCE: 'SOURCE',
  DOCUMENT_COMPLETE: 'COMPLETE',
};

export const EPA_PROJECT_TYPE = {
  PROJECT_HOME_DEPOT: 'home_depot',
};

export const ALLOWED_FILES_EXTENSION = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.csv',
];

export const STATUS_ACTION_TYPE = {
  CONTRACT_REVIEWED: 'Contract_Reviewed',
  ON_WAY: 'on-way',
};
export const WIDTH_SIZE = {
  WIDTH_150: 150,
  WIDTH_200: 200,
};

export const MARGIN_TOP_VALUES = {
  DOC_TYPE_2: {
    ALL_TRUE: '68px',
    ANY_TRUE: '36px',
    ONLY_BAR: '34px',
    DEFAULT: '2px',
  },
  DOC_TYPE_1: {
    ALL_TRUE: '44px',
    ANY_TRUE: '13px',
    ONLY_BAR: '9px',
    DEFAULT: '2px',
  },
};

export const REQUIRED_DOC_STATUS = {
  PENDING: 'Pending',
};

export const STATUS_OPTIONS = {
  NEW: 'New',
  TENTATIVELY_SCHEDULED: 'Tentatively Scheduled',
  COMPLETED: 'Completed',
  CONTRACT_PENDING: 'Contract_Pending',
  CX_SCHEDULED_STATUS: 'Customer Scheduled',
};

export const DEFAULT_COLOR_CODE = {
  client_id: clientDetails.clientId,
  color_code: '#5E5BA6',
  color_config_id: -1,
  color_name: 'Default',
  created_at: null,
  created_by: null,
  modified_at: null,
  modified_by: null,
};
export const ORDER_METHODS = [
  { id: 1, name: 'Email' },
  { id: 2, name: 'Fax' },
  { id: 3, name: 'EDI' },
];

export const DOCUMENT_STATUS = [
  { label: 'Internal Document', value: 'INTERNAL' },
  { label: 'Needs Review', value: 'NEEDS_REVIEW' },
  { label: 'Send to Source', value: 'SOURCE' },
  { label: 'Complete', value: 'COMPLETE' },
];
export const PO_STATUS = [
  { label: 'Order Generated', value: 'order_generated' },
  { label: 'Order Placed', value: 'order_placed' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'Complete', value: 'complete' },
  { label: 'Shipped', value: 'shipped' },
  { label: 'Received', value: 'received' },
  { label: 'Cancelled', value: 'cancelled' },
];
export const DOCUMENT_TYPE_PHOTO_VIDEO = ['Photo', 'Video'];
export const PO_TYPES = {
  project: {
    id: 'PROJECT',
  },
  general: {
    id: 'GENERAL',
  },
};
export const CONFIG_TAX_VALUES = {
  MIN_NON_ZERO_VALUE: 0.001,
  MAX_VALUE: 99.999,
  MIN_VALUE: 0.0,
  MIN_ONLY_VALUE: 0,
};
export const TAX_VALUES = {
  MIN_VALUE: '0.00',
};

export const TEMP_INSTALLATION = 'Temp Installation';

export const PROJECT_STATUS = {
  PROJECT_VIEW: 'project/view',
  PROJECT_EDIT: 'project/edit',
  PROJECT_COPY: 'project/copy',
  PROJECT_ADD: 'project/add',
  PROJECT_NEW_PROJECT: 'new-project',
  PROJECT_NEW_PROJECT_VIEW: 'new-project/view',
};

export const QUOTE_STATUS_NAMES = {
  NEW: 'New',
  APPROVED_BY_CUSTOMER: 'Approved by customer',
  VOID: 'Void',
  DECLINED_BY_CUSTOMER: 'Declined by customer',
  CONVERTED_TO_PROJECT: 'Converted to Project',
  CANCELLED: 'Cancelled',
  CHANGE_REQUESTED: 'Change Requested',
};

export const OVERALL_PAYMENT_STATUS = {
  AWAITING_ADVANCE_PAYMENT: 'Deposit Due',
  PAYMENT_DUE: 'Payment Due',
  PARTIAL_PAID: 'Partial Paid',
  PAID: 'Paid',
  OPEN: 'Open',
};
export const SIGNATURE_LOG_HISTORY_TYPE = {
  ANNOTATEDSIGNATURE: 1,
  FREEFORMSIGNATURE: 2,
};

export const INVOICE_STATUS_TYPE = {
  OPEN: 'Open',
  PARTIAL_PAID: 'Partial Paid',
};

export const EVENT_AND_PATH_CONSTANT = {
  USER_LOGIN: {
    EVENT: 'USER_LOGIN',
    PATH: 'LOGIN_PAGE',
  },
  USER_LOGOUT: {
    EVENT: 'USER_LOGOUT',
    PATH: 'LOGOUT_PAGE',
  },
  PROJECT_ADD: {
    EVENT: 'PROJECT_ADD',
    PATH: 'ADD_PROJECT',
  },
  PROJECT_UPDATE: {
    EVENT: 'PROJECT_UPDATE',
    PATH: 'EDIT_PROJECT',
  },
  PROJECT_ACTION_STATUS_UPDATE: {
    EVENT: 'PROJECT_STATUS_UPDATE',
    PATH: 'ACTION_BUTTON',
  },
  PROJECT_INSTALLER_UPDATE: {
    EVENT: 'INSTALLER_UPDATE',
    PATH: 'PROJECT_INSTALLER_UPDATE',
  },
  PROJECT_INSTALLER_ADD: {
    EVENT: 'INSTALLER_ADD',
    PATH: 'PROJECT_ADD_TECHNICIAN',
  },
  PROJECT_INSTALLER_DELETE: {
    EVENT: 'INSTALLER_DELETE',
    PATH: 'PROJECT_INSTALLER_DELETE',
  },
  PROJECT_NOTE_ADD: {
    EVENT: 'NOTE_ADD',
    PATH: 'PROJECT_NOTE_ADD',
  },
  PROJECT_NOTE_DELETE: {
    EVENT: 'NOTE_DELETE',
    PATH: 'PROJECT_NOTE_DELETE',
  },
  PROJECT_NOTE_VIEW: {
    EVENT: 'NOTE_VIEW',
    PATH: 'PROJECT_NOTE_VIEW',
  },
  PROJECT_NOTE_REVIEW: {
    EVENT: 'NOTE_REVIEW',
    PATH: 'PROJECT_NOTE_REVIEW',
  },
  PROJECT_CUSTOMER_CHAT_MESSAGE_EDIT: {
    EVENT: 'PROJECT_CUSTOMER_CHAT_MESSAGE_EDIT',
    PATH: 'PROJECT_CUSTOMER_CHAT_MESSAGE_EDIT',
  },
  PROJECT_CUSTOMER_CHAT_MESSAGE_DELETE: {
    EVENT: 'PROJECT_CUSTOMER_CHAT_MESSAGE_DELETE',
    PATH: 'PROJECT_CUSTOMER_CHAT_MESSAGE_DELETE',
  },
  PROJECT_CUSTOMER_CHAT_CLOSE_SESSION: {
    EVENT: 'PROJECT_CUSTOMER_CHAT_CLOSE_SESSION',
    PATH: 'PROJECT_CUSTOMER_CHAT_CLOSE_SESSION',
  },
  PROJECT_CUSTOMER_CHAT_NEW_SESSION: {
    EVENT: 'PROJECT_CUSTOMER_CHAT_NEW_SESSION',
    PATH: 'PROJECT_CUSTOMER_CHAT_NEW_SESSION',
  },
  PROJECT_CUSTOMER_CHAT_MESSAGE_SENT: {
    EVENT: 'PROJECT_CUSTOMER_CHAT_MESSAGE_SENT',
    PATH: 'PROJECT_CUSTOMER_CHAT_MESSAGE_SENT',
  },
  PROJECT_SMS_SEND: {
    EVENT: 'SMS_SEND',
    PATH: 'PROJECT_SMS_SEND',
  },
  PROJECT_SMS_UPDATE: {
    EVENT: 'SMS_UPDATE',
    PATH: 'PROJECT_SMS_UPDATE',
  },
  PROJECT_SMS_DELETE: {
    EVENT: 'SMS_DELETE',
    PATH: 'PROJECT_SMS_DELETE',
  },
  PROJECT_EMAIL_SEND: {
    EVENT: 'EMAIL_SENT',
    PATH: 'PROJECT_EMAIL_SEND',
  },
  PROJECT_LINK_CHILD: {
    EVENT: 'PROJECT_LINK',
    PATH: 'PROJECT_LINK_CHILD',
  },
  PROJECT_UNLINK_CHILD: {
    EVENT: 'PROJECT_UNLINK',
    PATH: 'PROJECT_UNLINK_CHILD',
  },
  PROJECT_ADDITIONAL_FEE_CHARGE_ADD: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_CHARGE_ADD',
    PATH: 'PROJECT_ADDITIONAL_FEE_CHARGE_ADD',
  },
  PROJECT_ADDITIONAL_FEE_CHARGE_EDIT: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_CHARGE_EDIT',
    PATH: 'PROJECT_ADDITIONAL_FEE_CHARGE_EDIT',
  },
  PROJECT_ADDITIONAL_FEE_CHARGE_DELETE: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_CHARGE_DELETE',
    PATH: 'PROJECT_ADDITIONAL_FEE_CHARGE_DELETE',
  },
  PROJECT_ADDITIONAL_FEE_EXPENSES_ADD: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_EXPENSES_ADD',
    PATH: 'PROJECT_ADDITIONAL_FEE_EXPENSES_ADD',
  },
  PROJECT_ADDITIONAL_FEE_EXPENSES_EDIT: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_EXPENSES_EDIT',
    PATH: 'PROJECT_ADDITIONAL_FEE_EXPENSES_EDIT',
  },
  PROJECT_ADDITIONAL_FEE_EXPENSES_DELETE: {
    EVENT: 'PROJECT_ADDITIONAL_FEE_EXPENSES_DELETE',
    PATH: 'PROJECT_ADDITIONAL_FEE_EXPENSES_DELETE',
  },
  PROJECT_LABOR_ITEM_MARK_ALL_FINANCE_REVIEW: {
    EVENT: 'PROJECT_LABOR_ITEM_MARK_ALL_FINANCE_REVIEW',
    PATH: 'PROJECT_LABOR_ITEM_MARK_ALL_FINANCE_REVIEW',
  },
  PROJECT_LABOR_ITEM_MARK_ALL_PAID: {
    EVENT: 'PROJECT_LABOR_ITEM_MARK_ALL_PAID',
    PATH: 'PROJECT_LABOR_ITEM_MARK_ALL_PAID',
  },
  PROJECT_LABOR_ITEM_ALL_CALCULATE_LABOR_COST: {
    EVENT: 'PROJECT_LABOR_ITEM_CALCULATE_LABOR_COST',
    PATH: 'PROJECT_LABOR_ITEM_ALL_CALCULATE_LABOR_COST',
  },
  PROJECT_LABOR_ITEM_ASSIGN: {
    EVENT: 'ASSIGN_PROJECT_LABOR_ITEM',
    PATH: 'PROJECT_LABOR_ITEM_ASSIGN',
  },
  PROJECT_LABOR_ITEM_EDIT: {
    EVENT: 'EDIT_PROJECT_LABOR_ITEM',
    PATH: 'PROJECT_LABOR_ITEM_EDIT',
  },
  PROJECT_LABOR_ITEM_DELETE: {
    EVENT: 'DELETE_PROJECT_LABOR_ITEM',
    PATH: 'PROJECT_LABOR_ITEM_DELETE',
  },
  PROJECT_LABOR_ITEM_CLONE: {
    EVENT: 'CLONE_PROJECT_LABOR_ITEM',
    PATH: 'PROJECT_LABOR_ITEM_CLONE',
  },
  PROJECT_LABOR_ITEM_PAID: {
    EVENT: 'PROJECT_LABOR_ITEM_PAID',
    PATH: 'PROJECT_LABOR_ITEM_PAID',
  },
  PROJECT_LABOR_ITEM_FINANCE_REVIEW: {
    EVENT: 'PROJECT_LABOR_ITEM_FINANCE_REVIEW',
    PATH: 'PROJECT_LABOR_ITEM_FINANCE_REVIEW',
  },
  PROJECT_LABOR_ITEM_INVOICE_CREATE: {
    EVENT: 'CREATE_PROJECT_ITEM_INVOICE',
    PATH: 'CREATE_PROJECT_ITEM_INVOICE',
  },
  PROJECT_LABOR_ITEM_INVOICE_EDIT: {
    EVENT: 'EDIT_PROJECT_LABOR_ITEM_INVOICE',
    PATH: 'EDIT_PROJECT_LABOR_ITEM_INVOICE',
  },
  PROJECT_LABOR_ITEM_ADD_NOTE: {
    EVENT: 'PROJECT_LABOR_ITEM_ADD_NOTE',
    PATH: 'PROJECT_LABOR_ITEM_ADD_NOTE',
  },
  PROJECT_LABOR_ITEM_EDIT_NOTE: {
    EVENT: 'PROJECT_LABOR_ITEM_EDIT_NOTE',
    PATH: 'PROJECT_LABOR_ITEM_EDIT_NOTE',
  },
  PROJECT_PRODUCT_ITEM_ADD_NOTE: {
    EVENT: 'PROJECT_PRODUCT_ITEM_ADD_NOTE',
    PATH: 'PROJECT_PRODUCT_ITEM_ADD_NOTE',
  },
  PROJECT_PRODUCT_ITEM_EDIT_NOTE: {
    EVENT: 'PROJECT_PRODUCT_ITEM_EDIT_NOTE',
    PATH: 'PROJECT_PRODUCT_ITEM_EDIT_NOTE',
  },
  PROJECT_LABOR_ITEM_ASSIGN_TECHNICIAN: {
    EVENT: 'PROJECT_LABOR_ITEM_ASSIGN_TECHNICIAN',
    PATH: 'PROJECT_LABOR_ITEM_ASSIGN_TECHNICIAN',
  },
  PROJECT_LABOR_ITEM_EDIT_ASSIGNED_TECHNICIAN: {
    EVENT: 'PROJECT_LABOR_ITEM_EDIT_ASSIGNED_TECHNICIAN',
    PATH: 'PROJECT_LABOR_ITEM_EDIT_ASSIGNED_TECHNICIAN',
  },
  PROJECT_LABOR_ITEM_UPDATE_STATUS: {
    EVENT: 'PROJECT_LABOR_ITEM_UPDATE_STATUS',
    PATH: 'PROJECT_LABOR_ITEM_UPDATE_STATUS',
  },
  PROJECT_LABOR_ITEM_DELETE_ASSIGNED_TECHNICIAN: {
    EVENT: 'PROJECT_LABOR_ITEM_DELETE_ASSIGNED_TECHNICIAN',
    PATH: 'PROJECT_LABOR_ITEM_DELETE_ASSIGNED_TECHNICIAN',
  },
  PROJECT_PRODUCT_ITEM_ASSIGN: {
    EVENT: 'ASSIGN_PROJECT_PRODUCT_ITEM',
    PATH: 'PROJECT_PRODUCT_ITEM_ASSIGN',
  },
  PROJECT_PRODUCT_ITEM_EDIT: {
    EVENT: 'EDIT_PROJECT_PRODUCT_ITEM',
    PATH: 'PROJECT_PRODUCT_ITEM_EDIT',
  },
  PROJECT_PRODUCT_ITEM_DELETE: {
    EVENT: 'DELETE_PROJECT_PRODUCT_ITEM',
    PATH: 'PROJECT_PRODUCT_ITEM_DELETE',
  },
  PROJECT_PRODUCT_ITEM_CLONE: {
    EVENT: 'CLONE_PROJECT_PRODUCT_ITEM',
    PATH: 'PROJECT_PRODUCT_ITEM_CLONE',
  },
  PROJECT_PRODUCT_ITEM_STATUS: {
    EVENT: 'PROJECT_PRODUCT_ITEM_STATUS_UPDATE',
    PATH: 'UPDATE_PROJECT_PRODUCT_ITEM_STATUS',
  },
  PROJECT_DOC_GET_FROM_SOURCE: {
    EVENT: 'PROJECT_DOC_GET_FROM_SOURCE',
    PATH: 'PROJECT_DOC_GET_FROM_SOURCE',
  },
  PROJECT_DOC_BULK_UPDATE: {
    EVENT: 'PROJECT_DOC_BULK_UPDATE',
    PATH: 'PROJECT_DOC_BULK_UPDATE',
  },
  PROJECT_DOC_ADD_FROM_TEMPLATE: {
    EVENT: 'PROJECT_DOC_ADD_FROM_TEMPLATE',
    PATH: 'PROJECT_DOC_ADD_FROM_TEMPLATE',
  },
  PROJECT_DOC_UPDATE: {
    EVENT: 'PROJECT_DOC_UPDATE',
    PATH: 'PROJECT_DOC_UPDATE',
  },
  PROJECT_DOC_ADD: {
    EVENT: 'PROJECT_DOC_ADD',
    PATH: 'PROJECT_DOC_ADD',
  },
  PROJECT_DOC_DOWNLOAD: {
    EVENT: 'PROJECT_DOC_DOWNLOAD',
    PATH: 'PROJECT_DOC_DOWNLOAD',
  },
  PROJECT_DOC_DELETE: {
    EVENT: 'PROJECT_DOC_DELETE',
    PATH: 'PROJECT_DOC_DELETE',
  },
  PROJECT_DOC_SEND_VIA_SMS: {
    EVENT: 'PROJECT_DOC_SEND_VIA_SMS',
    PATH: 'PROJECT_DOC_SEND_VIA_SMS',
  },
  PROJECT_DOC_SEND_VIA_EMAIL: {
    EVENT: 'PROJECT_DOC_SEND_VIA_EMAIL',
    PATH: 'PROJECT_DOC_SEND_VIA_EMAIL',
  },
  PROJECT_COPY_RELATED_DOC: {
    EVENT: 'PROJECT_COPY_RELATED_DOC',
    PATH: 'PROJECT_COPY_RELATED_DOC',
  },
  PROJECT_DOC_ACTION: {
    EVENT: 'PROJECT_DOC_ACTION',
    PATH: 'PROJECT_DOC_ACTION',
  },
  PROJECT_DOC_ACTION_WTIH_REVIEW: {
    EVENT: 'PROJECT_DOC_ACTION_WTIH_REVIEW',
    PATH: 'PROJECT_DOC_ACTION_WTIH_REVIEW',
  },
  PROJECT_REVIEW_DOC: {
    EVENT: 'PROJECT_REVIEW_DOC',
    PATH: 'PROJECT_REVIEW_DOC',
  },
  PROJECT_DOC_COMPLETE_ACTION: {
    EVENT: 'PROJECT_DOC_COMPLETE_ACTION',
    PATH: 'PROJECT_DOC_COMPLETE_ACTION',
  },
  PROJECT_DOC_SEND_TO_SOURCE: {
    EVENT: 'PROJECT_DOC_SEND_TO_SOURCE',
    PATH: 'PROJECT_DOC_SEND_TO_SOURCE',
  },
  PROJECT_ADD_PHOTO_VIDEOS: {
    EVENT: 'PROJECT_ADD_PHOTO_VIDEOS',
    PATH: 'PROJECT_ADD_PHOTO_VIDEOS',
  },
  PROJECT_BULK_UPDATE_PHOTO_VIDEOS: {
    EVENT: 'PROJECT_BULK_UPDATE_PHOTO_VIDEOS',
    PATH: 'PROJECT_BULK_UPDATE_PHOTO_VIDEOS',
  },
  PROJECT_DOWNLOAD_PHOTO_VIDEOS: {
    EVENT: 'PROJECT_DOWNLOAD_PHOTO_VIDEOS',
    PATH: 'PROJECT_DOWNLOAD_PHOTO_VIDEOS',
  },
  PROJECT_DELETE_PHOTO_VIDEOS: {
    EVENT: 'PROJECT_DELETE_PHOTO_VIDEOS',
    PATH: 'PROJECT_DELETE_PHOTO_VIDEOS',
  },
  PROJECT_SEND_TO_SOURCE_PHOTO_VIDEOS: {
    EVENT: 'PROJECT_SEND_TO_SOURCE_PHOTO_VIDEOS',
    PATH: 'PROJECT_SEND_TO_SOURCE_PHOTO_VIDEOS',
  },
  PROJECT_PHOTO_VIDEOS_MARK_AS_REVIEWED: {
    EVENT: 'PROJECT_PHOTO_VIDEOS_MARK_AS_REVIEWED',
    PATH: 'PROJECT_PHOTO_VIDEOS_MARK_AS_REVIEWED',
  },
  PROJECT_BILLING_PAYMENT_REQUEST_ADD: {
    EVENT: 'PROJECT_BILLING_PAYMENT_REQUEST_ADD',
    PATH: 'PROJECT_BILLING_PAYMENT_REQUEST_ADD',
  },
  PROJECT_BILLING_PAYMENT_REQUEST_EDIT: {
    EVENT: 'PROJECT_BILLING_PAYMENT_REQUEST_EDIT',
    PATH: 'PROJECT_BILLING_PAYMENT_REQUEST_EDIT',
  },
  PROJECT_BILLING_PAYMENT_REQUEST_DELETE: {
    EVENT: 'PROJECT_BILLING_PAYMENT_REQUEST_DELETE',
    PATH: 'PROJECT_BILLING_PAYMENT_REQUEST_DELETE',
  },
  PROJECT_BILLING_GENERATE_PAYMENT: {
    EVENT: 'PROJECT_BILLING_GENERATE_PAYMENT',
    PATH: 'PROJECT_BILLING_GENERATE_PAYMENT',
  },
  PROJECT_ISSUES_ADD: {
    EVENT: 'PROJECT_ISSUES_ADD',
    PATH: 'PROJECT_ISSUES_ADD',
  },
  PROJECT_ISSUES_EDIT: {
    EVENT: 'PROJECT_ISSUES_EDIT',
    PATH: 'PROJECT_ISSUES_EDIT',
  },
  PROJECT_ISSUES_DELETE: {
    EVENT: 'PROJECT_ISSUES_DELETE',
    PATH: 'PROJECT_ISSUES_DELETE',
  },
  PROJECT_CHARGEBACK_ADD: {
    EVENT: 'PROJECT_CHARGEBACK_ADD',
    PATH: 'PROJECT_CHARGEBACK_ADD',
  },
  PROJECT_CHARGEBACK_EDIT: {
    EVENT: 'PROJECT_CHARGEBACK_EDIT',
    PATH: 'PROJECT_CHARGEBACK_EDIT',
  },
  PROJECT_CHARGEBACK_DELETE: {
    EVENT: 'PROJECT_CHARGEBACK_DELETE',
    PATH: 'PROJECT_CHARGEBACK_DELETE',
  },
  PROJECT_CHARGEBACK_PAYOUT_ADD: {
    EVENT: 'PROJECT_CHARGEBACK_PAYOUT_ADD',
    PATH: 'PROJECT_CHARGEBACK_PAYOUT_ADD',
  },
  PROJECT_CHARGEBACK_PAYOUT_EDIT: {
    EVENT: 'PROJECT_CHARGEBACK_PAYOUT_EDIT',
    PATH: 'PROJECT_CHARGEBACK_PAYOUT_EDIT',
  },
  PROJECT_EPA_UPDATE: {
    EVENT: 'PROJECT_EPA_UPDATE',
    PATH: 'PROJECT_EPA_UPDATE',
  },
  EVENT_PROJECT_PHONE_CALL: {
    EVENT: 'PROJECT_PHONE_CALL',
    PATH: 'project_phone_call',
  },
  EVENT_PROJECT_OPEN_MAP: {
    EVENT: 'PROJECT_OPEN_MAP',
    PATH: 'project_open_map',
  },
  EVENT_PROJECT_ADD_AVAILABILITY_STATUS: {
    EVENT: 'PROJECT_ADD_AVAILABILITY_STATUS',
    PATH: 'project_add_availability_status',
  },
  EVENT_PROJECT_UPDATE_AVAILABILITY_STATUS: {
    EVENT: 'PROJECT_UPDATE_AVAILABILITY_STATUS',
    PATH: 'project_update_availability_status',
  },
};
export const EMAIL_SEND_TO_OPTIONS = [
  { label: 'Customer', value: 1 },
  { label: 'Store', value: 2 },
];

export const SOURCE_SYSTEM_OPTIONS = {
  LOWES: 'Lowes',
};

export const MONTHS_OF_YEAR = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const UNASSIGNED_TECHNICIAN_ID = 'f9641f98-e8da-11ed-a676-0233e0c2f500';

export const SOCKET_EVENTS = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  JOIN_PROJECT: 'join_project',
  LEAVE_PROJECT: 'leave_project',
  GET_ACTIVE_USERS: 'get_active_users',
  PRESENCE_UPDATE: 'presence_update',
  CONNECT_ERROR: 'connect_error',
  HEARTBEAT: 'heartbeat',
  CLIENT_SCHEDULING_LOCKED_USER: 'client_scheduling_locked_user',
};

export const MODULES = {
  ENTITY: {
    BASE_ROUTE: '/entity',
    ENTITY_ROUTE_WITH_PARAM: '/entity/:entityTypeId',
    ADD_FORM_ROUTE: '/entity/add',
    ADD_FORM_ROUTE_WITH_PARAM: '/entity/:entityTypeId/add',
    VIEW_FORM_ROUTE: '/entity/view',
    VIEW_FORM_ROUTE_WITH_PARAM: '/entity/:entityTypeId/view/:submissionId',
    EDIT_FORM_ROUTE: '/entity/edit',
    EDIT_FORM_ROUTE_WITH_PARAM: '/entity/:entityTypeId/edit/:submissionId',
    TITLE: 'Custom',
    ADD_FORM_TITLE: 'Add Form',
    VIEW_FORM_TITLE: 'View Form',
    EDIT_FORM_TITLE: 'Edit Form',
    IDENTIFIER: 'entity',
    DYNAMIC_FORMS: 'Dynamic Forms',
  },
  SUPPORT: {
    BASE_ROUTE: '/support',
    TICKET_ROUTE: '/support/ticket',
    TICKET_ROUTE_WITH_PARAM: '/support/ticket/:ticketId',
    TITLE: 'Support Tickets',
    TICKET_DETAIL_TITLE: 'Support Ticket',
    IDENTIFIER: 'support',
    MAIN_CUBE_NAME_LOWERCASE: 'support ticket',
  },
};

export const AVATAR_COLORS = [
  '#7c3aed',
  '#4f46e5',
  '#2563eb',
  '#0d9488',
  '#16a34a',
  '#d97706',
  '#ea580c',
  '#db2777',
  '#e11d48',
];

export const SCHEDULE_NOW_POLL = {
  STATUS_MAX_ATTEMPTS: REACT_APP_STATUS_MAX_ATTEMPTS,
  STATUS_ATTEMPT_INTERVAL: REACT_APP_STATUS_POLL_INTERVAL,
};
export const RESTRICTED_COPY_THUMB_PAGE_WIDTH_PX = 160;
export const RESTRICTED_COPY_THUMB_PREVIEW_HEIGHT_PX = Math.round(
  (RESTRICTED_COPY_THUMB_PAGE_WIDTH_PX * 11) / 8.5
);
export const RESTRICTED_COPY_THUMBS_PER_ROW = 4;

export const LOGOUT_TITLES = [
  'Logged Out',
  'Password Changed',
  'Session Expired',
];

export const REQUIRED_USER_FIELDS = [
  'role_id',
  'email',
  'first_name',
  'last_name',
];

export const DEFAULT_TIME_SLOT = '08:00 AM - 05:00 PM';
export const EDI_ORDER_METHOD = 3;
